module.exports = __webpack_public_path__ + "img/research.2c0aacec.png";